export const globalModule = (window as any) || {};
